import { render, staticRenderFns } from "./ProjectVersionCardContent.vue?vue&type=template&id=2f2b7933&"
import script from "./ProjectVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./ProjectVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports